<template>
  <div class="modal-manage-related-event-container">
    <!-- Find Events section -->
    <div class="choose-events-section">
      <div class="section-title h4-text">Find Events</div>
      <div class="field-input-wrapper mt-2">
        <div class="input-wrapper">
          <b-input-group>
            <b-form-input class="placeholder-italic input-search-event" :class="{'marginTop6px': fixElement}" v-model.lazy="textSearch"
                          type="text"
                          placeholder="Search for events" :formatter="format"></b-form-input>
            <div class="search-icon"></div>
          </b-input-group>
        </div>
      </div>

      <!-- Find Event header -->
      <div class="list-events remove-margin-side margin-side">
        <div class="list-header mb-3">
          <div class="column width-20">
            <div class="container-column border-seperate">
              <p class="text-header">Event Date</p>
              <b-button @click="onSort">
                <img src="../../../static/img/arrow-down.svg" alt="icon"/>
              </b-button>
            </div>
          </div>
          <div class="column width-20">
            <div class="container-column border-seperate">
              <p class="text-header">Event Name</p>
              <b-button @click="onSort">
                <img src="../../../static/img/arrow-down.svg" alt="icon"/>
              </b-button>
            </div>
          </div>
          <div class="column width-30">
            <div class="container-column border-seperate">
              <p class="text-header">Shipping Address</p>
              <b-button @click="onSort">
                <img src="../../../static/img/arrow-down.svg" alt="icon"/>
              </b-button>
            </div>
          </div>
          <div class="column width-20">
            <div class="container-column">
              <p class="text-header">Onsite Contact</p>
              <b-button @click="onSort">
                <img src="../../../static/img/arrow-down.svg" alt="icon"/>
              </b-button>
            </div>
          </div>
          <div class="column width-10">
            <div class="container-column">
            </div>
          </div>
        </div>

        <!-- Find Event data -->
        <div class="list-loading d-flex justify-content-center" v-if="isSearchLoading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <div v-if="!isSearchLoading">
          <div class="list-container" v-for="(item, index) in eventsAvailable" :key="index" >
            <div class="list-content" >
              <div class="column width-20">
                <div class="container-column border-seperate">
                  <p>{{item.prefDate}}</p>
                </div>
              </div>
              <div class="column width-20">
                <div class="container-column border-seperate">
                  <p>{{item.eventName}}</p>
                </div>
              </div>
              <div class="column width-30">
                <div class="container-column border-seperate">
                  <div class="text-icon">
                    <p>{{item.shippingAddress}}</p>
                  </div>
                </div>
              </div>
              <div class="column width-20">
                <div class="container-column">
                  <div class="text-icon">
                    <p>{{item.contactName}}</p>
                  </div>
                </div>
              </div>
              <div class="column width-10">
                <div class="container-column">
                  <div v-if="item.relatedStatus" class="added">Added</div>
                  <div v-else class="icon-add-wrapper" @click="addEventRelated(item)">
                    <div class="icon-add"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Related Events section -->
    <div class="added-events-section">
      <div class="section-title h4-text">
        Related Events
        <span class="ml-1" v-if="relatedEvents.length >= 0">({{relatedEvents.length + 1}})</span>
      </div>
      <div class="section-title h5-text mt-3">
        Related Events Title
      </div>

      <div class="field-input-wrapper mt-2">
        <div class="input-wrapper">
          <b-input-group>
            <b-form-input class="placeholder-italic input-search-event" :class="{'marginTop6px': fixElement}" v-model.lazy="groupName"
                          type="text"
                          :placeholder="'Enter the title for your group of related events'" :formatter="format"></b-form-input>
          </b-input-group>
        </div>
      </div>

      <!-- Related Events header -->
      <div class="list-events remove-margin-side margin-side">
        <div class="list-header mb-3">
          <div class="column width-20">
            <div class="container-column border-seperate">
              <p class="text-header">Event Date</p>
              <b-button @click="onSort">
                <img src="../../../static/img/arrow-down.svg" alt="icon"/>
              </b-button>
            </div>
          </div>
          <div class="column width-20">
            <div class="container-column border-seperate">
              <p class="text-header">Event Name</p>
              <b-button @click="onSort">
                <img src="../../../static/img/arrow-down.svg" alt="icon"/>
              </b-button>
            </div>
          </div>
          <div class="column width-30">
            <div class="container-column border-seperate">
              <p class="text-header">Shipping Address</p>
              <b-button @click="onSort">
                <img src="../../../static/img/arrow-down.svg" alt="icon"/>
              </b-button>
            </div>
          </div>
          <div class="column width-20">
            <div class="container-column">
              <p class="text-header">Onsite Contact</p>
              <b-button @click="onSort">
                <img src="../../../static/img/arrow-down.svg" alt="icon"/>
              </b-button>
            </div>
          </div>
          <div class="column width-10">
            <div class="container-column">
            </div>
          </div>
        </div>

        <!-- Current Event data -->
        <div>
          <template>
            <div class="list-container">
              <div class="list-content">
                <div class="column width-20">
                  <div class="container-column border-seperate">
                    <p>{{currentEvent.prefDate}}</p>
                  </div>
                </div>
                <div class="column width-20">
                  <div class="container-column border-seperate">
                    <p>{{currentEvent.eventName}}</p>
                  </div>
                </div>
                <div class="column width-30">
                  <div class="container-column border-seperate">
                    <p>{{currentEvent.shippingAddress}}</p>
                  </div>
                </div>
                <div class="column width-20">
                  <div class="container-column">
                    <p>{{currentEvent.contactName}}</p>
                  </div>
                </div>
                <div class="column width-10">
                  <div class="container-column">
                    <p class="selected-text">Selected Event</p>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- Related Events data -->
          <div class="list-container" v-for="(item, index) in relatedEvents" :key="index" >
            <div class="list-content" >
              <div class="column width-20">
                <div class="container-column border-seperate">
                  <p>{{item.prefDate}}</p>
                </div>
              </div>
              <div class="column width-20">
                <div class="container-column border-seperate">
                  <p>{{item.eventName}}</p>
                </div>
              </div>
              <div class="column width-30">
                <div class="container-column border-seperate">
                  <div class="text-icon">
                    <p>{{item.shippingAddress}}</p>
                  </div>
                </div>
              </div>
              <div class="column width-20">
                <div class="container-column">
                  <div class="text-icon">
                    <p>{{item.contactName}}</p>
                  </div>
                </div>
              </div>
              <div class="column width-10">
                <div class="container-column">
                  <div class="icon-close-wrapper" @click="removeEventRelated(item)">
                    <div class="icon-close"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="group-btn">
      <button class="ap-btn primary" :disabled="disableBtnSave" @click="saveRelatedEvents">Save</button>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import _ from 'lodash';
  import Icon from 'vue-awesome/components/Icon';

  export default {
    name: 'add-client-body-modal',
    components: {
      Icon
    },
    data () {
      return {
        eventsAvailable: [],
        groupName: null,
        textSearch: '',
        isSearchLoading: false,
        disableBtnSave: false,
        cache: {
          relatedEvents: null,
          eventsAvailable: null,
          groupName: null
        }
      };
    },
    props: {
      relatedEvents: {
        type: Array,
        default: []
      },
      currentEvent: null,
      eventId: {
        type: Number,
        default: 0
      }
    },
    methods: {
      hideModal () {
        this.resetData();
        this.$modal.hide('relatedEventsModal');
      },
      onSort () {
      },
      onCancel () {
        this.resetData();
      },
      resetData () {
        this.relatedEvents = this.cache.relatedEvents || this.relatedEvents;
        this.eventsAvailable = this.cache.eventsAvailable || this.eventsAvailable;
        this.groupName = this.cache.groupName || this.groupName;
      },
      cacheData () {
        this.cache.relatedEvents = _.cloneDeep(this.relatedEvents)
        this.cache.eventsAvailable = _.cloneDeep(this.eventsAvailable);
        this.cache.groupName = this.groupName
      },
      clearCacheData () {
        this.cache.relatedEvents = null;
        this.cache.eventsAvailable = null;
        this.cache.groupName = null;
      },
      addEventRelated (event) {
        let index = this.eventsAvailable.indexOf(event);
        if (index >= 0) {
          this.cacheData();
          this.eventsAvailable[index].relatedStatus = true;
          this.relatedEvents.push(event);
        }
      },
      removeEventRelated (event) {
        let index = this.relatedEvents.indexOf(event);
        if (index >= 0) {
          this.cacheData();
          this.relatedEvents.splice(index, 1);
          let ind = this.eventsAvailable.findIndex((element) => {
            return element.id === event.id;
          });
          if (ind >= 0) {
            this.eventsAvailable[ind].relatedStatus = false;
          } else {
            event.relatedStatus = false;
            this.eventsAvailable.push(event);
          }
        }
      },
      saveRelatedEvents () {
        this.disableBtnSave = true;
        let listRelatedEventIds = this.relatedEvents.map(e => e.id);

        let params = {
          eventId: this.eventId,
          relatedEventsId: listRelatedEventIds,
          groupName: this.groupName
        };

        this.addOrRemoveRelatedEvents(params).then(async response => {
          let groupId = this.currentEvent.eventGroupId || this.currentEvent.id;
          await this.$store.commit('MUTATION_SET_CURRENT_RELATED_EVENTS', this.relatedEvents);
          await this.$store.commit('MUTATION_UPDATE_EVENT_GROUP', {
            groupId: groupId,
            groupName: this.groupName,
            data: response.relatedEventDto
          });

          this.$toastr('success', 'Save related events successful!', '');
          this.clearCacheData();
          this.disableBtnSave = false;
        });
      },
      ...mapActions({
        searchRelatedEvents: 'ACTION_SEARCH_RELATED_EVENTS',
        addOrRemoveRelatedEvents: 'ACTION_ADD_REMOVE_RELATED_EVENTS'
      })
    },
    watch: {
      textSearch: _.debounce(function (newValue, oldValue) {
        if (newValue === oldValue) return;
        this.searchRelatedEvents({eventId: this.eventId, searchString: this.textSearch}).then(response => {
          this.eventsAvailable = response.eventShortList;
        });
      }, 500)
    },
    created () {
      this.isSearchLoading = true;
      this.relatedEvents = _.cloneDeep(this.relatedEvents);
      this.groupName = this.currentEvent.eventGroupName || this.currentEvent.eventName;

      this.searchRelatedEvents({eventId: this.eventId, searchString: null}).then(response => {
        this.eventsAvailable = response.eventShortList;
        this.isSearchLoading = false;
      });
    }
  }
</script>





// WEBPACK FOOTER //
// ManageRelatedEvents.vue?0ab2b7ce